import React from 'react';
import Clinicinfo from './components/clinic/clinicinfo';
import Patients from './components/patients/patient-list';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './index.css';
import Trials from './components/trials/trials';
import EditClinic from './components/clinic/edit-clinic';
import RecruiterList from './components/recruiters/recruiters-list';
import EditRecruiters from './components/recruiters/edit-recruiters';
import "./css/default.css";
import "./css/theme/purple.css";
import MasterLayout from './components/layout/master-layout';
import AddRecruiter from './components/recruiters/add-recruiter';
import AddClinic from './components/clinic/add-clinic';
import EditPatient from './components/patients/edit-patient';
import TrialStatuses from './components/trials/trial-statuses';
import Workflow from './components/workflow/workflow-list';
import Login from './components/login/login';
import { useEffect, useRef } from 'react';
import WorkflowFromScratch from './components/workflow/workflow-from-scratch';
import Conversation from './components/conversations/conversation';
import Dashboard from './components/dashboard/dashboard';
import WorkflowDetails from './components/workflow/workflow-details';
import ForgotPassword from './components/login/forgot-password';
import PersonalInfo from './components/personal-info/personal-info';
import EditPersonalInfo from './components/personal-info/edit-personal-info';
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "./reducer/slices/user/userSlice";
import { getTrails } from './reducer/slices/trial/get-trial-slice';
import { getTrailsName } from './reducer/slices/trial/get-trial-name-slice';
import { getClinicInformation } from './reducer/slices/clinic/get-clinicinfo-slice';
import { getRecruiterLists } from './reducer/slices/recruiter/get-recruiter-slice';
import AddPatient from './components/patients/add-patients';
import ResetPassword from './components/login/reset-password';
import ConversationList from './components/conversations/conversation-list';
import ConversationPatients from './components/conversations/conversation-patients';
import IntegrationDashboard from './components/integrations/integration-dashboard';
import Calendar from './components/integrations/calendar/calendar';
import PrivateRoute from './guards/private-route';


function App() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch()
  const hasFetched = useRef(false);

  useEffect(() => {
    if (user.isAuthenticated && !hasFetched.current) {
      hasFetched.current = true;
      if (user.userProfile && !user.userProfile.userID) {
      dispatch(fetchUserProfile({}))
      }
      dispatch(getTrails({}))
      dispatch(getClinicInformation({}));
      dispatch(getRecruiterLists({}))
      dispatch(getTrailsName({}))
    }
  }, [user.isAuthenticated])
  
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Public Routes */}

          <Route path="/" element={user.isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
          <Route path="/login" element={user.isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} />
          <Route path="/forgot-password" element={user.isAuthenticated ? <Navigate to="/dashboard" /> : <ForgotPassword />} />
          <Route path="/reset-password/:token" element={user.isAuthenticated ? <Navigate to="/dashboard" /> : <ResetPassword />} />

          <Route element={<PrivateRoute><MasterLayout /></PrivateRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/personal-info" element={<PersonalInfo />} />
            <Route path="/edit-personal-info" element={<EditPersonalInfo />} />

            <Route path="/locations" element={<Clinicinfo />} />
            <Route path="/edit-location" element={<EditClinic />} />
            <Route path="/add-location" element={<AddClinic />} />

            <Route path="/patients" element={<Patients />} />
            <Route path="/edit-patient" element={<EditPatient />} />
            <Route path="/add-patient" element={<AddPatient />} />

            <Route path="/recruiters" element={<RecruiterList />} />
            <Route path="/edit-recruiter" element={<EditRecruiters />} />
            <Route path="/add-recruiter" element={<AddRecruiter />} />

            <Route path="/trials" element={<Trials />} />
            <Route path="/trial-statuses" element={<TrialStatuses />} />
            <Route path="/trial-statuses/:key" element={<TrialStatuses />} />

            <Route path="/workflow" element={<Workflow />} />
            <Route path="/trial/:id" element={<WorkflowDetails />} />
            <Route path="/create-trial" element={<WorkflowFromScratch />} />

            <Route path="/conversations/:id" element={<Conversation />} />
            <Route path="/conversation-patients/:id" element={<ConversationPatients />} />

            <Route path="/conversation-list/:id?" element={<ConversationList />} />

            <Route path="/calendar" element={<Calendar />} />
            <Route path="/integrations" element={<IntegrationDashboard />} />
          </Route>
        </Routes>
      </Router>
    </div>

  );
}

export default App;
